import { useIsEdgeLocal } from "../../../hooks/useEdgeMode";

/**
 * „Една сметка" за резервация на няколко маси се вижда в Маркиране като
 * „14 | 13 | 12" (картата в „Списък", заглавието на панела в „Схема") — така
 * я казва и „Какво ще стане" в модалите „Настани" (тук и в Маркиране). В
 * локален режим резервацията по сметката е остаряло копие — там масата си
 * остава „14".
 */
export const useJoinedSeatNames = (): boolean => !useIsEdgeLocal();
